import { Cancel01Icon } from '@hugeicons/core-free-icons';
import { IconButton, TextBold } from '@sunrise-ui/primitives';
import React from 'react';
import { StyleSheet, View } from 'react-native';

type Props = {
  onClose: () => void;
  title?: string;
};
export function DesktopModalHeader({ onClose, title }: Props) {
  return (
    <View style={styles.container}>
      <TextBold style={styles.title}>{title}</TextBold>
      <IconButton
        icon={Cancel01Icon}
        onPress={onClose}
        style={styles.closeButton}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  title: {
    paddingLeft: 30,
    textAlign: 'center',
    width: '100%',
    fontSize: 24,
  },
  closeButton: {
    marginTop: 3,
  },
});
